import React, { useEffect } from "react";
import { Button, Modal, Form, Input } from "antd";

import * as Types from "../commons/typeDTO";

function ModalAssignCoupon({
    open,
    coupon,
    onChangedOpen,
    onAssignCouponInfo,
}: {
    open: boolean;
    coupon: Types.CouponDto;
    onChangedOpen: (open: boolean) => void;
    onAssignCouponInfo?: (couponId: number, email: string) => void;
}) {
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, [open]);

    useEffect(() => {
        form.setFieldsValue(coupon);
    }, [coupon]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        onChangedOpen(false);
        onAssignCouponInfo && onAssignCouponInfo(coupon.couponId, values.email);
    };

    return (
        <Modal
            centered
            forceRender
            closable={false}
            className="login"
            open={open}
            title={"쿠폰 할당"}
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="setPassword" type="primary" onClick={() => form.submit()}>
                    {"할당"}
                </Button>,
            ]}
        >
            <Form form={form} onFinish={onFinish}>
                <Form.Item name="couponName" label="쿠폰 제목">
                    <Input disabled placeholder="쿠폰 제목"></Input>
                </Form.Item>
                <Form.Item
                    name="email"
                    label="이메일"
                    rules={[
                        {
                            required: true,
                            message: "이메일을 입력해 주세요.",
                        },
                    ]}
                >
                    <Input placeholder="이메일"></Input>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ModalAssignCoupon;
